import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { BeamlineStatus } from './beamline-status';


@Injectable({
  providedIn: 'root'
})
export class BeamlineServService {

  constructor(private http: HttpClient) { }

  getBeamlineStatus(): Observable<BeamlineStatus[]> {
    return this.http.get<BeamlineStatus[]>(environment.urls.baseApiUrl + '/BeamlineStatus');
  }

}
